import type { DeviationFE, VehicleFE } from 'domain/vehicle';
import type { GenericRecord } from 'services/utils';

export const getVehicleByVin = (vehicleData: GenericRecord<VehicleFE> | undefined, vin: VehicleFE['vin']) =>
    vehicleData?.[vin];

export const getVehicleIdentifier = (vehicle: VehicleFE) =>
    vehicle.name || vehicle.licensePlate || vehicle.vin.slice(-7);

/**
 * Flattens a vehicle's monitored deviations field into a list of plain {@link DeviationFE} objects,
 * discarding empty field wrappers. Lets existing helpers (setSeverity, getOldestDeviation) keep
 * operating on a flat DeviationFE[].
 */
export const flattenFeDeviations = (vehicle: VehicleFE): DeviationFE[] =>
    vehicle.deviations.map(field => field.value?.value).filter((value): value is DeviationFE => !!value);
